/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m1.7987 12.4425.2246-.2352 2.171-2.171a.7675.7675 0 0 1 1.1743.9792l-.0888.1063-2.171 2.1709c-2.0982 2.0983-2.0982 5.5002 0 7.5985 2.0283 2.0283 5.2748 2.0959 7.3844.2028l.214-.2028 2.171-2.171a.7677.7677 0 0 1 1.1743.9792l-.0888.1063-2.171 2.171c-2.6977 2.6977-7.0716 2.6977-9.7694 0-2.6207-2.6207-2.6955-6.8231-.2246-9.5342ZM13.5068 2.906c2.1096-1.8931 5.3561-1.8255 7.3844.2028 2.0982 2.0982 2.0982 5.5002 0 7.5984l-2.171 2.171-.0888.1063a.7679.7679 0 0 0 .0888.9792.7675.7675 0 0 0 1.0855 0l2.171-2.171.2246-.2352c2.4709-2.711 2.3961-6.9135-.2246-9.5342-2.6978-2.6977-7.0717-2.6977-9.7694 0l-2.171 2.171-.0888.1063a.7678.7678 0 0 0 1.1743.9792l2.171-2.171.214-.2028Zm3.8486 3.7386.0006-.0006-.0006.0006L6.0952 16.8124C17.5985 5.8023 17.1125 5.8021 16.8128 6.1017c1.3813.6806 1.3518.267 1.0855.0004l.0884.9792-.0888.1063C6.3944 18.1978 6.8804 18.1979 7.1802 17.8983c-1.3813-.6806-1.3518-.2669-1.0855-.0004l-.0884-.9792"
    clipRule="evenodd"
  />,
  'LinkTo'
);
